import React from 'react';
import { ShipmentStatus, StatusEvent } from '../types/shipment';
import { portalTranslations } from '../i18n/portalTranslations';
import { SupportedLanguage } from '../i18n/translations';
import { formatPortalDate, getStatusOrder } from '../services/shipmentService';
import './StatusTimeline.css';

const icons: Record<ShipmentStatus, string> = {
  arrived: '🚢',
  inspection: '🔍',
  clearance: '📋',
  release: '✅',
  delivered: '📦',
};

interface StatusTimelineProps {
  current: ShipmentStatus;
  language: SupportedLanguage;
  compact?: boolean;
  history?: StatusEvent[];
  showNotes?: boolean;
}

const StatusTimeline: React.FC<StatusTimelineProps> = ({
  current,
  language,
  compact = false,
  history = [],
  showNotes = false,
}) => {
  const steps = getStatusOrder();
  const labels = portalTranslations[language].tracker.steps;
  const currentIndex = steps.indexOf(current);
  const historyByStatus = new Map(history.map((h) => [h.status, h]));

  return (
    <div className={`status-timeline ${compact ? 'status-timeline-compact' : ''} ${showNotes ? 'status-timeline-detailed' : ''}`}>
      {steps.map((step, index) => {
        const event = historyByStatus.get(step);
        const done = index <= currentIndex;
        const active = index === currentIndex;
        return (
          <div
            key={step}
            className={`status-timeline-step ${done ? 'done' : ''} ${active ? 'active' : ''}`}
          >
            <span className="status-timeline-dot">{icons[step]}</span>
            <span className="status-timeline-label">{labels[step]}</span>
            {event?.at && (
              <span className="status-timeline-date">
                {formatPortalDate(event.at, language)}
              </span>
            )}
            {showNotes && event?.note && (
              <span className="status-timeline-note">{event.note}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StatusTimeline;
